import { ProductOptions } from './ProductOptions';
import { AddToCart } from '../../snippets';
import { RechargeSubscriptionWidget } from '../../snippets/RechargeSubscriptionWidget/RechargeSubscriptionWidget';
import { useGlobalProductPageContext } from '../../contexts/globalProductPageContext';

export function ProductDetails({
  product,
  productDetailAccordionsSection,
  selectedOptions,
  selectedVariant,
  setSelectedOptions,
  scrollReference,
}) {
  const { purchaseType, selectedSellingPlan, productSubscriptionWidget } =
    useGlobalProductPageContext();

  const hideOptions =
    product.variants?.length === 1 &&
    product.variants[0].title === 'Default Title';

  return (
    <div className="product-details flex flex-col gap-3 md:gap-5 md:pl-4 lg:pl-10 xl:pl-16">
      {!hideOptions && (
        <ProductOptions
          product={product}
          selectedOptions={selectedOptions}
          selectedVariant={selectedVariant}
          setSelectedOptions={setSelectedOptions}
        />
      )}
      {productDetailAccordionsSection || (
        <>
          {productSubscriptionWidget && (
            <RechargeSubscriptionWidget
              product={product}
              widgetContent={productSubscriptionWidget}
            />
          )}

          <AddToCart
            isPdp
            selectedVariant={selectedVariant}
            product={product}
            purchaseType={purchaseType}
            selectedSellingPlan={selectedSellingPlan}
          />
          <div ref={scrollReference} />
        </>
      )}
    </div>
  );
}

ProductDetails.displayName = 'ProductDetails';
